module.exports = __webpack_public_path__ + "img/mega_2.a5901a93.png";